import { CloudUploadOutlined } from '@ant-design/icons'
import type { UploadProps } from 'antd'
import { RcFile } from 'antd/es/upload'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext, useState } from 'react'
import UploadModal from '../Base/UploadModal'
import { CommonUploadProps } from '../types'

const props: UploadProps = {
  name: 'file',
  multiple: true,
  showUploadList: false,
  maxCount: 1,
};

export default function GenericUpload({
  title = 'upload.file_upload',
  subtitle = 'upload.select_file',
  icon = <CloudUploadOutlined />,
  onConfirm,
  onCancel,
  onFailedFileValidation,
  onValidation
}: CommonUploadProps) {
  const t = useContext(I18nContext)

  const [subtitleToShow, setSubtitleToShow] = useState<string>(t(subtitle))
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(true)

  const handleConfirm = (file?: RcFile) => {
    setConfirmButtonDisabled(true)
    setSubtitleToShow(t(subtitle))
    if (file) {
      onConfirm(file)
    }
  }

  const handleCancel = () => {
    setSubtitleToShow(t(subtitle))
    setConfirmButtonDisabled(true)
    if (onCancel) {
      onCancel()
    }
  }

  const handleValidation = (file: RcFile) => {
    if (!onValidation) {
      setConfirmButtonDisabled(false)
      return setSubtitleToShow(`${t('upload.selected_file')}: ${file.name}`)
    }
    const fileIsValid = onValidation(file)
    setConfirmButtonDisabled(!fileIsValid)
    setSubtitleToShow(fileIsValid ? `${t('upload.selected_file')}: ${file.name}` : t('upload.invalid_file'));
  }

  return (
    <UploadModal
      validationCallback={handleValidation}
      props={props}
      title={title}
      subtitle={subtitleToShow}
      confirmDisabled={confirmButtonDisabled}
      onConfirmCallback={handleConfirm}
      onCancelCallback={handleCancel}
      onFailedFileValidation={onFailedFileValidation}
      icon={icon}
    />
  )
}
